import { SnackBarHelper } from '@lyearn-team/frontend-components';
import getTwilioVideo from '../utils/getTwilioVideo';

export default async function connectRoom(roomName, roomToken) {
  try {
    const { connect } = await getTwilioVideo();
    const room = await connect(
      roomToken,
      {
        name: roomName,
        audio: { name: 'audio' },
        video: { name: 'video' }
      }
    );
    console.log(`Successfully joined a Room: ${room}`);
    return room;
  } catch (error) {
    console.log(`Error joining room: ${error.message}`);
    SnackBarHelper.showSnackbar({
      label:
        'There seems to be error connecting to live class. Please make sure that you are using latest version on Google Chrome on Desktop. If problem still persists, try restarting your browser or contact support.',
      status: 'error'
    });
    throw error;
  }
}
